import "./styles.css";
import { getFirebaseConfig, isMockModeEnabled } from "./config";
import { createFirebaseAuthProvider, createMockAuthProvider } from "./auth";
import { createMockHandoffRedeemer, createServerHandoffRedeemer } from "./handoff";
import { createMockOwnerAccessRepository, createServerOwnerAccessRepository } from "./roles";
import { mountApp, renderApp } from "./shell";

const root = document.querySelector<HTMLDivElement>("#app");

if (!root) {
  throw new Error("App root not found.");
}

try {
  const env = import.meta.env;
  const mockMode = isMockModeEnabled(env);
  if (!mockMode) {
    getFirebaseConfig(env);
  }
  const authProvider = mockMode ? createMockAuthProvider() : createFirebaseAuthProvider(env);
  const ownerAccess = mockMode ? createMockOwnerAccessRepository() : createServerOwnerAccessRepository(env);
  const handoffRedeemer = mockMode ? createMockHandoffRedeemer() : createServerHandoffRedeemer(env);
  mountApp(root, authProvider, ownerAccess, handoffRedeemer, mockMode);
} catch (error) {
  root.innerHTML = renderApp({
    kind: "config-error",
    message: error instanceof Error ? error.message : "Configuration failed."
  });
}
